















import { Component, Vue } from 'vue-property-decorator'
import { $myPeer } from '@/index'
import { PeerModule } from '@/store'

@Component
export default class Words extends Vue {
  $peer: $myPeer;
  words: string[] = ['', '', '', '', ''];

  storeWords (e) {
    e.preventDefault()
    const filtered = [...new Set(this.words)].filter(Boolean)
    if (filtered.length !== 5) {
      alert('Please check duplicates, words must be unique.')
      return
    }
    PeerModule.sendMessage({ type: 'ADD_WORDS', payload: this.words })
    this.$router.replace('board')
  }
}
